// const apiUrl = 'https://cors-anywhere.herokuapp.com/' + process.env.REACT_APP_API_URL
const apiUrl = process.env.REACT_APP_API_URL
export default apiUrl
